import { render, staticRenderFns } from "./daum-postcode.vue?vue&type=template&id=07b48e7a"
import script from "./daum-postcode.vue?vue&type=script&lang=js"
export * from "./daum-postcode.vue?vue&type=script&lang=js"
import style0 from "./daum-postcode.vue?vue&type=style&index=0&id=07b48e7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports